import React from 'react'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'
import { PALETTE } from '../../../styles/constants'

function TwoSidedTextContent({ textColor = { value: PALETTE.gray80 }, backgroundColor = { value: PALETTE.gray10 }, textLeft, textRight }) {
  return (
    <div className={styles.wrapper} style={{ color: textColor.value, backgroundColor: backgroundColor.value }}>
        <div className={styles.textBlock}>
          <SimpleBlockContent blocks={textLeft}/>
        </div>
        <div className={styles.textBlock}>
          <SimpleBlockContent blocks={textRight}/>
        </div>
    </div>
  )
}

export default TwoSidedTextContent
